// extracted by mini-css-extract-plugin
export default {"-large":"VM8CF6HYClClnwuWxDkJ","fontHeading":"GHe5LkMkmj8o4_TyOyOj","icon":"zJrRPwm7itTNftcvuYDW"};